exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-item .store-logo img[data-v-36c3c07a]{width:70px;height:auto}.selected-location[data-v-36c3c07a]{width:400px;max-width:400px}@media only screen and (max-width:768px){.map-section .map_canvas[data-v-36c3c07a]{height:100%}#pg-location .content-wrapper[data-v-36c3c07a]{min-height:500px}}", ""]);

// exports
